import { lazy } from "react";

const POS = lazy(() => import("../Sales/POS/POS"));
const CashSalesInvoice = lazy(() =>
  import("../Sales/CashSalesInvoice/CashSalesInvoice")
);
const CashSalesInvoiceList = lazy(() =>
  import("../Sales/CashSalesInvoice/List/CashSalesInvoiceList")
);
const ViewCashSalesInvoice = lazy(() =>
  import("../Sales/CashSalesInvoice/View/ViewCashSalesInvoice")
);
const Status = lazy(() => import("../Sell/Status/Status"));
const Quotes = lazy(() => import("../Sales/POS/QuoteSale/Quotes/Quotes"));
const SalesHistory = lazy(() => import("../Sell/SaleHistory/SalesHistory"));
const SellReturnForm = lazy(() =>
  import("../Sales/SaleReturn/SellReturnForm")
);
const SaleReturns = lazy(() =>
  import("../Sales/SaleReturn/List/SaleReturns")
);
const DirectReturnForm = lazy(() =>
  import("../Sales/DirectReturn/DirectReturnForm")
);
const ViewSellReturn = lazy(() =>
  import("../Sales/SaleReturn/ViewSellReturn")
);
const CloseReg = lazy(() =>
  import("../Sales/POS/Register/CloseReg/CloseReg")
);
const CommissionSetup = lazy(() =>
  import("../Sales/Commission/Setup/CommissionSetup")
);
const CommissionReport = lazy(() =>
  import("../Sales/Commission/Report/CommissionReport")
);

export const salesRoutes = (access, settings) => [
  { path: "/pos/*", element: POS, title: "pos", enabled: settings?.fiscalYearId && access.posAccess },
  { path: "/cash_sales_invoice", element: CashSalesInvoiceList, title: "cashSalesInvoice", enabled: settings?.fiscalYearId && access.cashSalesInvoiceAccess },
  { path: "/cash_sales_invoice/new", element: CashSalesInvoice, title: "newCashSalesInvoice", enabled: settings?.fiscalYearId && access.cashSalesInvoiceAccess && (access.cashSalesInvoice?.create ?? true) },
  { path: "/cash_sales_invoice/view/:id", element: ViewCashSalesInvoice, title: "viewCashSalesInvoice", enabled: settings?.fiscalYearId && access.cashSalesInvoiceAccess },
  { path: "/status", element: Status, title: "status", enabled: settings?.fiscalYearId && access.status },
  { path: "/quotes", element: Quotes, title: "quotes", enabled: settings?.fiscalYearId && access.pos?.quote },
  { path: "/sales_history", element: SalesHistory, title: "salesHistory", enabled: settings?.fiscalYearId && access.salesHistoryAccess },
  { path: "/sales_history/:customerId", element: SalesHistory, title: "salesHistory", enabled: settings?.fiscalYearId && access.salesHistoryAccess },
  { path: "/sell_return_form/:invoiceId", element: SellReturnForm, title: "saleReturnForm", enabled: settings?.fiscalYearId && access.pos?.returnSale },
  { path: "/sale_returns", element: SaleReturns, title: "saleReturns", enabled: settings?.fiscalYearId && access.pos?.returnSale },
  { path: "/view_sale_return/:id", element: ViewSellReturn, title: "viewSaleReturn", enabled: settings?.fiscalYearId && access.pos?.returnSale },
  { path: "/direct_return", element: DirectReturnForm, title: "directReturn", enabled: settings?.fiscalYearId && access.pos?.returnSale },
  { path: "/close_reg", element: CloseReg, title: "closeRegister", enabled: settings?.fiscalYearId && access.pos?.registerClosing },
  { path: "/commission_setup", element: CommissionSetup, title: "commissionSetup", enabled: settings?.fiscalYearId && access.commissionAccessNav?.setup },
  { path: "/commission_report", element: CommissionReport, title: "commissionReport", enabled: settings?.fiscalYearId && access.commissionAccessNav?.report },
];
